import axios from 'axios';
import store from "@/store";

const config = async (key) => {
  const { data } = await axios.get(`/config/${key}`);
  return data;
}

const updateSessionToken = async () => {
  const keycloak = store.state.keycloak;
  const { status } = await axios.post('/session', {
    accessToken: keycloak.token,
    refreshToken: keycloak.refreshToken
  });
  const expires = (keycloak.tokenParsed.exp - keycloak.tokenParsed.iat) / 60;
  console.info(`Session token updated with status ${status} (expires in ${expires} min)`);
}

const toSnakeCase = str => str &&
      str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map(x => x.toLowerCase())
      .join('_');

const mockApi = (response = [], error = false, responseTime = 1000) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (error) {
        reject(new Error('Something terrible happened.'));
      } else {
        resolve(response);
      }
    }, responseTime);
  })
}

export {
  config,
  updateSessionToken,
  toSnakeCase,
  mockApi
}